export default "__VITE_ASSET__OE5s4t8D__"